module.exports = __webpack_public_path__ + "static/media/copy-green.fa018595.svg";